import get from 'lodash/get';
import { graphql, parse } from './utils.js';

export const SITE_DISABLED_MESSAGE =
	'Your license of ERIN is no longer valid. Please contact your company admin for more information.';

// Roles only ever assigned to ERIN staff. Same list as the AppSync guard.
const INTERNAL_STAFF_ROLES = ['superAdmin', 'systemAdmin', 'supportAdmin'];

// A company with disableSite blocks every sign-in except internal staff:
// support admins (admin.permissions '*') and staff-only roles. The AppSync
// guard and the api lambda enforce the same rule server-side; this is the
// UI-side copy so blocked users get the license message instead of a
// generic error.
export const isSiteDisabledForUser = (user) => {
	if (!user) return false;
	const supportAdmin = parse(get(user, 'admin'));
	const isInternalStaff =
		get(supportAdmin, 'permissions') === '*' ||
		INTERNAL_STAFF_ROLES.includes(get(user, 'role'));
	return !isInternalStaff && get(user, 'company.disableSite', false) === true;
};

// Signup and claim landing pages are visited without a Cognito session, so
// this goes through the apiKey lambda proxy rather than Apollo (whose auth
// link redirects anonymous visitors to /logout). Fails open on a transport
// error so a proxy blip cannot block signup; the server-side gates remain.
export const fetchCompanyDisableSite = async (companyId) => {
	if (!companyId) return false;
	try {
		const company = await graphql({
			input: { id: companyId },
			query: 'getCompany',
		});
		return get(company, 'disableSite', false) === true;
	} catch (error) {
		console.error(error);
		return false;
	}
};
